import React from 'react'

const Ir4755enbp = () => {
  return (
    <div>
      <h1>Ir47553nbp.js</h1>
    </div>
  )
}

export default Ir4755enbp
